export function ticketCodeLabel(ticket: { id: string; ticketCode?: string | null }): string {
  return ticket.ticketCode ?? `HD-${ticket.id}`;
}
